<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <b-field
            label="Type"
            custom-class="is-small"
          >
            <b-select
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.searchType"
              @input="updateSearchTerm($store.state.evaluation.saleCompGroup.saleCompInputs.searchType)"
            >
              <option
                v-for="saleCompSearchType in this.$store.state.searchTypes"
                :key="saleCompSearchType.type"
              >{{ saleCompSearchType.type }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="level-item">
          <b-field
            :label="termLabel"
            custom-class="is-small"
          >
            <b-input
              style="width: 200%"
              @focus="$event.target.select()"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.searchTerm"
            ></b-input>
          </b-field>
        </div>
      </div>
      <div class="level-right">
        <div class="level">
          <div class="columns">
            <div
              class="column"
              v-if="$store.state.evaluation.compDataSource != 'Discovery'"
            >
              <b-field
                label="Confine To county"
                custom-class="is-small"
              >
                <b-select
                  placeholder="Confine to county"
                  v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.confineToCounty"
                >
                  <option value="">Any county</option>
                  <option
                    :value="county"
                    v-for="county in $store.state.evaluation.saleCompGroup.counties"
                    :key="county"
                  >{{ county }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="Confine To zip"
                custom-class="is-small"
              >
                <b-select
                  placeholder="Confine to zip"
                  v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.confineToZip"
                >
                  <option value="">Any zip</option>
                  <option
                    :value="zip"
                    v-for="zip in $store.state.evaluation.saleCompGroup.zips"
                    :key="zip"
                  >{{ zip }}</option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="is-size-7 ">Subject property information</div>
    <div class="level">
      <div class="columns">
        <div class="column">
          <div class="is-size-7">{{ $store.state.evaluation.sqft }}</div>
          <b-field
            label="Sqft +/-"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.sqftPlusMinus"
            ></b-input>
          </b-field>
          <b-field
            label="Ignore fields"
            custom-class="is-small"
          >
            <b-checkbox
              @click="ignoreFields = $store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
            ></b-checkbox>
          </b-field>
        </div>
        <div class="column">
          <div class="is-size-7">{{ $store.state.evaluation.beds }}</div>
          <b-field
            label="Beds min"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.bedsMin"
            ></b-input>
          </b-field>
          <b-field
            @focus="$event.target.select()"
            label="Beds max"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.bedsMax"
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <div class="is-size-7 ">{{ $store.state.evaluation.baths }}</div>
          <b-field
            label="Baths min"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.bathsMin"
            ></b-input>
          </b-field>
          <b-field
            label="Baths max"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.bathsMax"
            ></b-input>
          </b-field>
        </div>
        <div
          class="column"
          v-if="$store.state.evaluation.compDataSource != 'Discovery'"
        >
          <div class="is-size-7 ">{{ $store.state.evaluation.garage }}</div>
          <b-field
            label="Garage min"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.garageMin"
            ></b-input>
          </b-field>
          <b-field
            label="Garage max"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.garageMax"
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <div class="is-size-7 ">{{ $store.state.evaluation.yearBuilt }}</div>
          <b-field
            label="Year built +/-"
            custom-class="is-small"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-bind:disabled="$store.state.evaluation.saleCompGroup.saleCompInputs.ignoreParametersExceptMonthsClosed"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.yearBuiltPlusMinus"
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <div class="is-size-7 ">.</div>
          <b-field
            label="Months closed"
            custom-class="is-small"
            v-if="$store.state.evaluation.compDataSource != 'Discovery'"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.monthsClosed"
            ></b-input>
          </b-field>
          <b-field
            label="Months market"
            custom-class="is-small"
            v-if="$store.state.evaluation.compDataSource == 'Discovery'"
          >
            <b-input
              @focus="$event.target.select()"
              type="number"
              v-model="$store.state.evaluation.saleCompGroup.saleCompInputs.monthsClosed"
            ></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <button
      class="button is-primary"
      @click="updateSaleComps($store.state.evaluation)"
    >Search</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ignoreFields: false,
      termLabel: "Term"
    };
  },

  methods: {
    updateSaleComps(evaluation) {
      this.$store.dispatch("updatePropertyEvaluationSaleComps", evaluation);
    },

    updateSearchTerm(searchType) {
      var match = this.$store.state.searchTypes.find(t => t.type == searchType);
      if (match)
        this.$store.state.evaluation.saleCompGroup.saleCompInputs.searchTerm =
          match.defaultSearchTerm;
      this.updateSearchTermLabel(searchType);
    },

    updateSearchTermLabel(searchType) {
      this.termLabel = searchType;
      if (searchType == "Radius") this.termLabel = "Radius in miles";
    }
  },

  mounted() {
    // Get the search types.
    var propertyId = this.$store.state.evaluation.propertyId;
    var evaluationId = this.$store.state.evaluation.id;
    this.$store.dispatch("getSearchTypes", { propertyId, evaluationId });
    this.updateSearchTermLabel(
      this.$store.state.evaluation.saleCompGroup.saleCompInputs.searchType
    );
  }
};
</script>

<style>
</style>
